import httpUtils from '../../utils/HttpUtils'

class ActivityService {

  //获取上线活动列表信息
  async list(sortType = '',status ='') {
    let result = null;
    try {
      result = await httpUtils.post('/activity/list',{sortType,status})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取历史活动列表信息
  async historyList(pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/activity/list/history',{pageNo})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  //获取活动详情信息
  async detail(id = '') {
    let result = null;
    try {
      result = await httpUtils.post('/activity/detail',{activityId:id})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取活动店铺信息
  async shopList(activityId = '',pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/activity/shop/list',{activityId,pageNo})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取活动商品信息
  async productList(activityId = '',shopId = '',pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/activity/product/list',{activityId,shopId,pageNo})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取活动商品信息
  async productDetail(activityProductId = '') {
    let result = null;
    try {
      result = await httpUtils.post('/activity/product/detail',{activityProductId})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //去报名参加团购
  async enrollCreate(activityId = ''){
    let result = null;
    try {
      result = await httpUtils.post('/activity/enroll/create',{activityId})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //保存团购信息
  async enrollSave(activityId = '',contactName = '',contactPhone = '',village = '',intend = '',newsmthAccount = '',enrollNum = '',wechat = ''){
    let result = null;
    try {
      let relation = 0;
      result = await httpUtils.post('/activity/enroll/save',{activityId,contactName,contactPhone,relation,village,intend,newsmthAccount,enrollNum,wechat})
    } catch (error) {
      console.log('连接失败', error);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new ActivityService()
